const { REGEX } = require("@dpdgroupuk/mydpd-enums");

export const getFileAttributes = (filePath = "") => {
  const { filePathRegexp, fileNameRegexp } =
    navigator.userAgent.indexOf("Win") !== -1
      ? {
          filePathRegexp: REGEX.WINDOWS_FILE_PATH,
          fileNameRegexp: REGEX.WINDOWS_FILE_NAME,
        }
      : {
          filePathRegexp: REGEX.UNIX_FILE_PATH,
          fileNameRegexp: REGEX.UNIX_FILE_NAME,
        };

  return {
    filePath,
    fileName: filePath.match(fileNameRegexp)?.[0],
    directoryPath: filePath.match(filePathRegexp)?.[0],
  };
};
